import { VariaveisAmbiente } from 'config';
import { useCallback } from 'react';
import { useApiBase } from '../../base/api-base';

export function useDeleteRemoverDestinatario() {
    const { invocarApi, ...outrasPropriedades } = useApiBase();

    const deleteRemoverDestinatario = useCallback(
        (propagandaId: string, destinatarioId: string) =>
            invocarApi({
                url: `/v1/Propaganda/${propagandaId}/Destinatarios/${destinatarioId}`,
                method: 'DELETE',
                baseURL: VariaveisAmbiente.apiPropaganda + '/api',
                enviarTokenUsuario: true,
            }),
        [invocarApi],
    );
    return {
        ...outrasPropriedades,
        deleteRemoverDestinatario,
    };
}
